// extracted by mini-css-extract-plugin
export default {"login-view":"LoginView_login-view__qboUW","message":"LoginView_message__CPydj"};